import { render, staticRenderFns } from "./TermsCreate.vue?vue&type=template&id=5744596a"
import script from "./TermsCreate.vue?vue&type=script&lang=js"
export * from "./TermsCreate.vue?vue&type=script&lang=js"
import style0 from "./TermsCreate.vue?vue&type=style&index=0&id=5744596a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports